import React from 'react';
import Quote_Icon from '../assets/format_quote.png';

const impactData = [
  {
    quote: "A 20-year-old student in Gaza is studying interior design while living through war and family struggles. With our grant covering her tuition, she can keep learning and memorizing Qur’an despite the challenges.",
    author: "A Student in Gaza",
    date: "Jan 5, 2025"
  },
  {
    quote: "A mother in her 30s paused her career to care for her daughter. With our grant, she’s taking Islamic studies classes in tafsīr, deepening her faith and hoping to pass that love of learning on to her child.",
    author: "A Mother in New York",
    date: "Apr 8, 2025"
  },
  {
    quote: "A new masjid had no resources after buying their building. With our grant, they were able to add books and learning materials, turning it into both a place of worship and a center for education.",
    author: "An Imam of a Masjid",
    date: "Sep 25, 2025"
  }
];

const ImpactSection = () => (
  <section className="impact-section" id="impacts">
    <h2 className="impact-title">Impact Of Our Grants</h2>
    <p className="impact-subtitle">See how your support is changing lives worldwide.</p>
    <div className="impact-cards">
      {impactData.map((item, idx) => (
        <div className="impact-card" key={idx}>
          {/* <div className="impact-quoteicon">
            <img src={Quote_Icon} alt="quote-icon" className="quote-icon"/>
          </div> */}
          <div className="impact-quote">{item.quote}</div>
          <div className="impact-author">- {item.author}</div>
          <div className="impact-date">{item.date}</div>
        </div>
      ))}
    </div>
  </section>
);

export default ImpactSection;
